import importer from "common/importer";
import axios from "axios";
const { deloitReq: req } = importer("APIs", null);
const Config = importer("Config");

let CORE_GOOGLE_API_KEY_ANDROID;
if (Config.PLATFORM_TYPE != "mobile") {
  CORE_GOOGLE_API_KEY_ANDROID = GOOGLE_API_KEY_ANDROID;
}
/**
 * ENDPOINT REMOVED
 * --
 * Get center matches
 * @param {String} city
 * @param {String} zipcode
 * @param {String} state
 */
export const searchCenters = (city, zipcode, state) => {
  return req.get("/centers/search", {
    params: {
      city,
      zipcode,
      state,
    },
  });
};
/**
 * Update Appointment Slots
 * @param {String} centerId
 * @param {Object} appointment
 */
export const addAppointmentSlot = (centerId, appointment, authToken) => {
  const config = {
    headers: {
      Authorization: authToken,
    },
  };
  return req.put(
    "/centers/" + centerId + "/appointment-slots",
    appointment,
    config
  );
};

/* UPDATED */

/**
 * Get Centers
 * @param {String} centerSfid
 */
export const getAllCenters = (centerSfid, authToken) => {
  return req.get("/centers", {
    headers: {
      Authorization: authToken,
    },
    params: {
      centerSfid,
    },
  });
};
/**
 * Get Centers
 * @param {String} centerSfid
 */
export const getAppointmentCenter = (centerSfid, authToken) => {
  return req.get("/centers", {
    headers: {
      Authorization: authToken,
    },
    params: {
      centerSfid,
    },
  });
};
/**
 * Get center matches for all donors
 * @param {String} searchStr
 */
export const getDonorCentersAll = (
  searchStr,
  isDIS8Center,
  searchType,
  addNewDonorBonusInformation
) => {
  return req.get("/centers/search-all", {
    params: {
      searchStr,
      isDIS8Center,
      searchType,
      addNewDonorBonusInformation,
    },
  });
};

/**
 * Get center matches for all donors
 * @param {String} stateName
 */
export const getStateCenters = (stateName) => {
  return req.get("/centers/state-centers", {
    params: {
      stateName,
    },
  });
};

export const getCoordinatesForZipcode = (zipCode) => {
  return req.get(`/centers/coordinates/${zipCode}`);
};

export const getZipcodeFromCoordinates = (lat, lng) => {
  return req.get("/centers/zipcode", {
    params: {
      lat,
      lng,
    },
  });
};

export const getZipcodeSearchedCenters = (
  searchStr,
  isDIS8Center,
  searchType,
  defaultCenter,
  addNewDonorBonusInformation
) => {
  return req.get("/centers/search-all", {
    params: {
      searchStr,
      isDIS8Center,
      searchType,
      defaultCenter,
      addNewDonorBonusInformation,
    },
  });
};

/**
 * Get Appointment Slot
 * @param {Date} fromDateTime
 * @param {Date} toDateTime
 * @param {Date} forDate
 * @param {String} centerSfid
 */
export const getAppointmentSlot = (
  fromDateTime,
  toDateTime,
  forDate,
  centerSfid,
  authToken
) => {
  return req.get("​/centers​/appointments​/slot-config", {
    headers: {
      Authorization: authToken,
    },
    params: {
      fromDateTime,
      toDateTime,
      forDate,
      centerSfid,
    },
  });
};
/**
 * Donor Calendar View - Available Slots For Appointment Type
 * @param {Date} forDate forDate ISO - 2020-06-14T00:00:00Z, If forDate is provided fromDateTime/toDateTime is optional
 * @param {Date} fromDateTime fromDateTime ISO - 2020-06-14T10:00:00Z, overrides forDate
 * @param {Date} toDateTime toDateTime ISO - 2020-06-14T12:00:00Z
 * @param {Number} numberOfChildren Number of children
 * @param {String} centerSfid Center ID - Salesforce Id
 * @param {String} appointmentType Appointment Type | Available values : DONATION, PHYSICAL, PLAYROOM
 * @param {Number} appointmentId Appointment Id of rescheduling Appointment
 */
export const getSlotsForAppointmentType = (
  forDate,
  fromDateTime,
  toDateTime,
  numberOfChildren,
  centerSfid,
  appointmentType,
  rescheduleId,
  donorSfid,
  authToken
) => {
  return req.get("/centers/appointments/available-slots", {
    headers: {
      Authorization: authToken,
    },
    params: {
      forDate,
      numberOfChildren,
      centerSfid,
      appointmentType,
      rescheduleId,
      donorSfid,
    },
    withCredentials: true,
  });
};
/**
 * Calendar View - Donor Details
 * @param {Date} forDate forDateTime ISO - 2020-06-14T10:00:00Z, If forDateTime is provided fromDateTime/toDateTime is optional
 * @param {Date} fromDateTime fromDateTime ISO - 2020-06-14T10:00:00Z, overrides forDate
 * @param {Date} toDateTime toDateTime ISO - 2020-06-14T12:00:00Z
 * @param {String} centerSfid Center ID - Salesforce Id
 */
export const getSlotsForDonor = (
  forDate,
  fromDateTime,
  toDateTime,
  centerSfid,
  authToken
) => {
  return req.get("/centers/appointment-calendar", {
    headers: {
      Authorization: authToken,
    },
    params: {
      forDate,
      fromDateTime,
      toDateTime,
      centerSfid,
    },
  });
};

/* NEW */

/**
 * Center Report
 * @param {Date} fromDateTime Time provided here is considered as the center time, if you want to fetch slots until 4PM center time, provide 2020-06-12T16:00:00
 * @param {Date} toDateTime Time provided here is considered as the center time, if you want to fetch slots until 4PM center time, provide 2020-06-12T16:00:00
 * @param {String} centerSfid Center ID - Salesforce Id
 * @param {String} appointmentType Available values : DONATION, PHYSICAL, PLAYROOM
 * @param {Number} limit Page size
 * @param {Number} page Page Number
 */
export const getDonorAppointmentsReport = (
  fromDateTime,
  toDateTime,
  centerSfid,
  appointmentType,
  limit,
  page,
  authToken
) => {
  return req.get("/centers/appointments/report", {
    headers: {
      Authorization: authToken,
    },
    params: {
      fromDateTime,
      toDateTime,
      centerSfid,
      appointmentType,
      pageSize: limit,
      currentPage: page,
    },
  });
};
export const getPotentialDonorsReport = (
  fromDateTime,
  toDateTime,
  centerSfid,
  sortByType,
  limit,
  page,
  authToken
) => {
  return req.get("/centers/potentialdonors/report", {
    headers: {
      Authorization: authToken,
    },
    params: {
      fromDateTime,
      toDateTime,
      centerSfid,
      sortByType,
      pageSize: limit,
      currentPage: page,
    },
  });
};
/**
 * Download Report
 * @param {Date} fromDateTime Time provided here is considered as the center time, if you want to fetch slots until 4PM center time, provide 2020-06-12T16:00:00
 * @param {Date} toDateTime Time provided here is considered as the center time, if you want to fetch slots until 4PM center time, provide 2020-06-12T16:00:00
 * @param {String} centerSfid Center ID - Salesforce Id
 * @param {String} appointmentType Available values : DONATION, PHYSICAL, PLAYROOM
 * @param {Number} limit Page size
 * @param {Number} page Page Number
 */
export const downloadAppointmentReport = (
  fromDateTime,
  toDateTime,
  centerSfid,
  appointmentType,
  fileType,
  limit,
  page,
  authToken
) => {
  return req.get("/centers/appointments/download", {
    headers: {
      Authorization: authToken,
    },
    params: {
      fromDateTime,
      toDateTime,
      centerSfid,
      appointmentType,
      fileType,
      limit,
      page,
    },
    responseType: "blob",
  });
};

export const downloadPotentialDonorsReport = (
  fromDateTime,
  toDateTime,
  centerSfid,
  sortByType,
  fileType,
  limit,
  page,
  authToken
) => {
  return req.get("/centers/potentialdonors/download", {
    headers: {
      Authorization: authToken,
    },
    params: {
      fromDateTime,
      toDateTime,
      centerSfid,
      sortByType,
      fileType,
      limit,
      page,
    },
    responseType: "blob",
  });
};

/**
 * Center Calendar
 * @param {Date} date Date for which the center calendar is to be fetched 2020-06-12T16:00:00
 * @param {Date} center Center Sfid eg. 'a0G0n000008wiP2EAI'
 */
export const getCenterCalendar = (date, center, token) => {
  return req.get("/centers/appointment-calendar", {
    headers: {
      Authorization: token,
    },
    params: {
      forDate: date,
      centerSfid: center,
    },
  });
};

/**
 * Center Slot config
 * @param {Date} date Date for which the center calendar is to be fetched 2020-06-12T16:00:00
 * @param {Date} center Center Sfid eg. 'a0G0n000008wiP2EAI'
 */
export const getCenterSlotConfig = (date, center, slotType, token) => {
  return req.get("/centers/appointments/slot-config", {
    headers: {
      Authorization: token,
    },
    params: {
      forDate: date,
      centerSfid: center,
      appoitmentType: slotType,
    },
  });
};

/**
 * Save Center Slot config
 */
export const saveCenterSlotConfig = (date, center, slotsArray, token) => {
  return req.put("/centers/appointments/slot-config", slotsArray, {
    headers: {
      Authorization: token,
    },
    params: {
      centerSfid: center,
      forDate: date,
    },
  });
};

/**
 * Save Center Slot config
 */
export const saveMassUpdateConfig = (
  date,
  center,
  slotsArray,
  startDate,
  endDate,
  weekDays,
  appointmentType,
  token
) => {
  return req.put(
    "/centers/appointments/bulk-slot-config",
    {
      fromDateTime: startDate,
      toDateTime: endDate,
      weekDays: weekDays,
      slotDetails: slotsArray,
      appointmentType,
    },
    {
      headers: {
        Authorization: token,
      },
      params: {
        centerSfid: center,
        forDate: date,
      },
    }
  );
};

/**
 * Get Donor center information.
 * @param {String} donorSfid
 */

export const getDonorCenterInfo = (donorSfid, token) => {
  return req.get("donors/nearby-centers", {
    headers: {
      Authorization: token,
    },
    params: {
      donorSfid,
    },
  });
};

/**
 * Get Alternate Donor centers information.
 * @param {String} donorSfid
 * @param {Date} openForDate
 */

export const getAlternateDonorCentersInfo = (donorSfid, token, openForDate) => {
  return req.get("donors/nearby-centers", {
    headers: {
      Authorization: token,
    },
    params: {
      donorSfid,
      openForDate,
    },
  });
};

export const getFavoriteCenterInfo = (donorSfid, token) => {
  return req.get("donors/favourite-centers", {
    headers: {
      Authorization: token,
    },
    params: { donorSfid },
  });
};

export const getCenterInfo = (locationName, locationState) => {
  return req.get("/centers/details", {
    params: {
      name: locationName,
      state: locationState,
    },
  });
};

// /**
//  * Update Fav Center Slot config
//  */
export const updateFavoriteCenter = (centerSfid, donorSfid, token) => {
  return req.put(
    "/donors/favourite-centers",
    {
      favouriteCenters: centerSfid,
      donorSfid: donorSfid,
    },
    {
      headers: {
        Authorization: token,
      },
    }
  );
};

/**
 * Create Application User
 * - Example -
 * {
 *   "name": "string",
 *   "role": "string",
 *   "logiId": "string",
 *   "defaultCenter": "string",
 * }
 */
export const createApplicationUser = (applicationUser, authToken) => {
  const config = {
    headers: {
      Authorization: authToken,
    },
  };
  return req.post("/employees/createApplicationUser", applicationUser, config);
};

/**
 * Search Application User
 * - Example -
 * {
        searchString: searchReq.searchString,
        pageSize: searchReq.pageSize,
        currentPage: searchReq.currentPage
    }
 */
export const searchApplicationUser = (searchReq, authToken) => {
  return req.get("/employees/searchApplicationUser", {
    headers: {
      Authorization: authToken,
    },
    params: {
      searchString: searchReq.searchString,
      pageSize: searchReq.pageSize,
      currentPage: searchReq.currentPage,
      centerSfid: searchReq.centerSfid,
    },
  });
};

/**
 * Get Application User Details
 * @param {string} loginId - email Id of the user
 */
export const getApplicationUserDetails = (searchReq, authToken) => {
  return req.get("/employees/getApplicationUserDetails", {
    headers: {
      Authorization: authToken,
    },
    params: {
      loginId: searchReq.loginId,
    },
  });
};

/**
 * Update Application User Details
 * @param {name,role} userDetailsReq -  user object
 */
export const updateApplicationUserDetails = (userDetailsReq, authToken) => {
  return req.put(
    "/employees/" + userDetailsReq.userId + "/UpdateProfile",
    {
      name: userDetailsReq.name,
      role: userDetailsReq.role,
    },
    {
      headers: {
        Authorization: authToken,
      },
    }
  );
};

/**
 * Update Application User default center
 * @param {centerSfid,userSfid} userDetailsReq - user object
 */
export const updateApplicationUserDefaultCenter = (
  userDetailsReq,
  authToken
) => {
  return req.put(
    "/employees/updateDefaultCenter",
    {
      centerSfid: userDetailsReq.centerSfid,
      userSfid: userDetailsReq.userSfid,
    },
    {
      headers: {
        Authorization: authToken,
      },
    }
  );
};

/**
 * remove application User center access
 * @param {id} id - email Id of the user
 */
export const removeApplicationUserCenterAccess = (id, authToken) => {
  return req.delete("/employees/" + id + "/deleteCenterAccess", {
    headers: {
      Authorization: authToken,
    },
  });
};

/**
 * save application User center access
 * @param {centerUser} id - request object
 */
export const saveApplicationUserCenterAccess = (centerUser, authToken) => {
  return req.post(
    "/employees/createCenterUserAccess",
    {
      donationCenter: centerUser.donationCenter,
      isDefault: centerUser.isDefault,
      loginId: centerUser.loginId,
    },
    {
      headers: {
        Authorization: authToken,
      },
    }
  );
};

/**
 * remove application User portal access
 * @param {id} id - user id
 */
export const removeApplicationUserPortalAccess = (id, authToken) => {
  return req.delete("/employees/" + id + "/deleteApplicationUserAccess", {
    headers: {
      Authorization: authToken,
    },
  });
};
